// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import {
  GoogleAuthProvider,
  browserLocalPersistence,
  getAuth,
  setPersistence,
  signInWithPopup,
  sendPasswordResetEmail,
  connectAuthEmulator,
} from "firebase/auth";

import { getFunctions, httpsCallable, connectFunctionsEmulator } from "firebase/functions";
import { getStorage, ref, uploadBytes } from "firebase/storage";


let firebaseConfig = null;
let apiDomain = null;

console.log("REACT_APP_ENV 12 3", process.env.REACT_APP_ENV)
if (process.env.REACT_APP_ENV === "live") {
  console.log("Production")
  apiDomain = "https://us-central1-blue-beagle-live.cloudfunctions.net";
  firebaseConfig = {
    apiKey: "AIzaSyAjeXczw4OLklaJNKFXaX-41ve53dnmRho",
    authDomain: "blue-beagle-live.firebaseapp.com",
    databaseURL: "https://blue-beagle-live-default-rtdb.firebaseio.com",
    projectId: "blue-beagle-live",
    storageBucket: "blue-beagle-live.appspot.com",
    messagingSenderId: "946118573334",
    appId: "1:946118573334:web:c54c2257a43e81f28da437",
    measurementId: "G-GJJHR5H531",
  };
} else if (process.env.REACT_APP_ENV === "local") {
  console.log("Local Development (Emulator)")
  apiDomain = "http://localhost:5001/blue-beagle-development/us-central1";
  firebaseConfig = {
    apiKey: "AIzaSyCx8Hrt8Sn-D-BxYGkRGPoyv8PLOf2E10g",
    authDomain: "blue-beagle-development.firebaseapp.com",
    databaseURL: "http://localhost:9000",
    projectId: "blue-beagle-development",
    storageBucket: "demo-project.appspot.com",
    messagingSenderId: "155344600831",
    appId: "1:155344600831:web:5a314f35c2ccfdc72316ca"
  };
} else {
  console.log("Development")
  apiDomain = "https://us-central1-blue-beagle-development.cloudfunctions.net";
  firebaseConfig = {
    apiKey: "AIzaSyCx8Hrt8Sn-D-BxYGkRGPoyv8PLOf2E10g",
    authDomain: "blue-beagle-development.firebaseapp.com",
    databaseURL: "https://blue-beagle-development-default-rtdb.firebaseio.com",
    projectId: "blue-beagle-development",
    storageBucket: "blue-beagle-development.appspot.com",
    messagingSenderId: "155344600831",
    appId: "1:155344600831:web:5a314f35c2ccfdc72316ca",
    measurementId: "G-PF9D9WFJPS",
  };
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
export const storage = getStorage(app);

// Connect to emulators when in local environment
if (process.env.REACT_APP_ENV === "local") {
  connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });
  connectFunctionsEmulator(getFunctions(app), "localhost", 5001);
}

setPersistence(auth, browserLocalPersistence)
  .then(() => {
    // Persistence set successfully
    // console.log("Persistence set successfully");
  })
  .catch((error) => {
    // Handle errors
    console.error("Error setting persistence:", error);
  });

// Initialize Firebase Auth provider
const provider = new GoogleAuthProvider();

// whenever a user interacts with the provider, we force them to select an account
provider.setCustomParameters({
  prompt: "select_account ",
});
export const signInWithGooglePopup = () => signInWithPopup(auth, provider);
export const resetPassword = (email) => sendPasswordResetEmail(auth, email);
const functions = getFunctions(app);
// USER
export const getUser = httpsCallable(functions, "getUser");
export const getUserCompanies = httpsCallable(functions, "getUserCompanies");
export const updateCompany = httpsCallable(functions, "updateCompany");
export const getCompanyStatistics = httpsCallable(functions, "getCompanyStatistics");
export const completeCompanyImageUpload = httpsCallable(functions, "completeCompanyImageUpload");
export const onboardCompany = httpsCallable(functions, "onboardCompany");

// DASHBOARD
export const dashboardSummary = httpsCallable(functions, "dashboardSummary");
//DEPARTMENT
export const getDepartments = httpsCallable(functions, "getDepartments");
export const createDepartment = httpsCallable(functions, "createDepartment");
export const deleteDepartment = httpsCallable(functions, "deleteDepartment");
export const updateDepartment = httpsCallable(functions, "updateDepartment");
//ROLES
export const getRoles = httpsCallable(functions, "getRoles");
export const createRole = httpsCallable(functions, "createRole");
export const deleteRole = httpsCallable(functions, "deleteRole");
export const updateRole = httpsCallable(functions, "updateRole");

// PROPERTY
export const getProperty = httpsCallable(functions, "getProperty");
export const getProperties = httpsCallable(functions, "getProperties");
export const createProperty = httpsCallable(functions, "createProperty");
export const updateProperty = httpsCallable(functions, "updateProperty");
export const deleteProperty = httpsCallable(functions, "deleteProperty");
export const completePropertyImageUpload = httpsCallable(functions, "completePropertyImageUpload");
export const aiAssistentReport = httpsCallable(functions, "aiAssistentReport");
export const cloneProperty = httpsCallable(functions, "cloneProperty");

// AREAKEYS
export const getAreaKeys = httpsCallable(functions, "getAreaKeys");
export const createAreaKey = httpsCallable(functions, "createAreaKey");
export const updateAreaKey = httpsCallable(functions, "updateAreaKey");
export const deleteAreaKey = httpsCallable(functions, "deleteAreaKey");

// TICKETS
export const getTickets = httpsCallable(functions, "getTickets");
export const getTicket = httpsCallable(functions, "getTicket");
export const createTicket = httpsCallable(functions, "createTicket");
export const updateTicket = httpsCallable(functions, "updateTicket");
export const deleteTicket = httpsCallable(functions, "deleteTicket");
export const getTicketActivities = httpsCallable(functions, "getTicketActivities");
export const deleteGalleryAsset = httpsCallable(functions, "deleteGalleryAsset");

// ASSOCIATES
export const getAssociates = httpsCallable(functions, "getAssociates");
export const createAssociate = httpsCallable(functions, "createAssociate");
export const updateAssociate = httpsCallable(functions, "updateAssociate");
export const deleteAssociate = httpsCallable(functions, "deleteAssociate");
export const unlinkAssociate = httpsCallable(functions, "unlinkAssociate");
export const completeAssociateImageUpload = httpsCallable(functions, "completeAssociateImageUpload");
export const deleteAssociateImage = httpsCallable(functions, "deleteAssociateImage");

// ASSOCIATES NOTIFICATION SETTINGS
export const updateAssociateNotificationSettings = httpsCallable(functions, "updateAssociateNotificationSettings");
export const getAssociateNotificationSettings = httpsCallable(functions, "getAssociateNotificationSettings");

// LOCATIONS
export const liveLocations = httpsCallable(functions, "liveLocations");

// SCHEDULES
export const getSchedules = httpsCallable(functions, "getSchedules");
export const getSchedule = httpsCallable(functions, "getSchedule");
export const getPlannedSchedules = httpsCallable(functions, "getPlannedSchedules");
export const createSchedule = httpsCallable(functions, "createSchedule");
export const updateSchedule = httpsCallable(functions, "updateSchedule");
export const deleteSchedule = httpsCallable(functions, "deleteSchedule");
export const generateScheduleSummaryPDF = httpsCallable(functions, "generateScheduleSummaryPDF");
export const cloneSchedule = httpsCallable(functions, "cloneSchedule");
export const moveSchedule = httpsCallable(functions, "moveSchedule");
export const getAreas = httpsCallable(functions, "getAreas");
export const createArea = httpsCallable(functions, "createArea");
export const updateArea = httpsCallable(functions, "updateArea");
export const deleteArea = httpsCallable(functions, "deleteArea");
export const getTasks = httpsCallable(functions, "getTasks");
export const createTask = httpsCallable(functions, "createTask");
export const updateTask = httpsCallable(functions, "updateTask");
export const deleteTask = httpsCallable(functions, "deleteTask");

export default auth;

// SCHEDULE SUMMARIES
export const getScheduleSummaries = httpsCallable(functions, "getScheduleSummaries");
export const getScheduleSummary = httpsCallable(functions, "getScheduleSummary");
export const deleteScheduleSummaryGalleryAsset = httpsCallable(functions, "deleteScheduleSummaryGalleryAsset");
export const completeScheduleSummaryGalleryUpload = httpsCallable(functions, "completeScheduleSummaryGalleryUpload");

// API
export const firebaseAPIDomain = apiDomain;
export const createCompanyToken = httpsCallable(functions, "createCompanyToken");

// COMMUNICATION
export const sendEmail = httpsCallable(functions, "sendEmail");
export const sendSMS = httpsCallable(functions, "sendSMS");

// AI

export const aiTicketsSummary = httpsCallable(functions, "aiTicketsSummary");
export const aiGetConversations = httpsCallable(functions, "aiGetConversations");
export const aiUpdateConversation = httpsCallable(functions, "aiUpdateConversation");
export const aiDeleteConversation = httpsCallable(functions, "aiDeleteConversation");

// BILLING
export const getSubscriptionPlans = httpsCallable(functions, "getSubscriptionPlans");
export const getBillingInfo = httpsCallable(functions, "getBillingInfo");
export const updateBillingInfo = httpsCallable(functions, "updateBillingInfo");
export const createCheckoutSession = httpsCallable(functions, "createCheckoutSession");
export const getBillingPortalUrl = httpsCallable(functions, "getBillingPortalUrl");
export const upgradeAddOn = httpsCallable(functions, "upgradeAddOn");
export const cancelAddOn = httpsCallable(functions, "cancelAddOn");
export const upgradePlan = httpsCallable(functions, "upgradePlan");
export const cancelPlan = httpsCallable(functions, "cancelPlan");

export const createTicketGalleryAsset = async (uid, ticketId, asset) => {
  console.log("createTicketGalleryAsset", uid, ticketId, asset);
  const storage = getStorage();

  // Convert data URLs to Blob
  const dataURLToBlob = (dataURL) => {
    const byteString = atob(dataURL.split(',')[1]);
    const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  };

  const thumbnailBlob = dataURLToBlob(asset.thumbnailUrl);
  const assetBlob = dataURLToBlob(asset.assetUrl);

  const thumbnailRef = ref(storage, `dropbox/${uid}/tickets/${ticketId}/thumbnail.jpg`);
  await uploadBytes(thumbnailRef, thumbnailBlob);

  const assetRef = ref(storage, `dropbox/${uid}/tickets/${ticketId}/asset.jpg`);
  await uploadBytes(assetRef, assetBlob);

  const completeTicketGalleryUpload = httpsCallable(functions, 'completeTicketGalleryUpload');
  try {
    const result = await completeTicketGalleryUpload({ ticketId, assetType: 'photo' });
    return result.data?.galleryAssets;
  } catch (error) {
    console.error("Error calling function:", error);
    throw error;
  }
};

export const createScheduleSummaryGalleryAsset = async (uid, scheduleSummaryId, asset) => {
  const storage = getStorage();

  // Convert data URLs to Blob
  const dataURLToBlob = (dataURL) => {
    const byteString = atob(dataURL.split(',')[1]);
    const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  };

  const thumbnailBlob = dataURLToBlob(asset.thumbnailUrl);
  const assetBlob = dataURLToBlob(asset.assetUrl);

  const thumbnailRef = ref(storage, `dropbox/${uid}/scheduleSummaries/${scheduleSummaryId}/thumbnail.jpg`);
  await uploadBytes(thumbnailRef, thumbnailBlob);

  const assetRef = ref(storage, `dropbox/${uid}/scheduleSummaries/${scheduleSummaryId}/asset.jpg`);
  await uploadBytes(assetRef, assetBlob);

  const completeTicketGalleryUpload = httpsCallable(functions, 'completeScheduleSummaryGalleryUpload');
  try {
    const result = await completeTicketGalleryUpload({ scheduleSummaryId, assetType: 'photo' });
    return result.data?.galleryAssets;
  } catch (error) {
    console.error("Error calling function:", error);
    throw error;
  }
}